import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const Clubs = () => {
    useEffect(() => {
        document.title = 'Clubs -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
               
                <li>The Almanac</li>
                 <li>Clubs</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Clubs </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12"> 
                 <p>There are a number of Clubs in the School with their set of activities. They are as follows:</p>
                <div className="table-responsive maintable">
                <table className="table">
                   <thead>
                          <tr>
                           <th>    CLUB</th>
                           <th>OBJECTIVES </th> 
                         </tr>
                   </thead>
                     <tbody> 
                     <tr> <td>  Home Science Club </td> <td>  To develop aesthetic skills and make students self-reliant. </td> </tr> <tr> <td> Mathematics Club </td> <td> To recognise the utility of maths in daily life and develop inductive and deductive reasoning </td> </tr>  <tr> <td> Literati Club </td> <td> To promote reading, research and creative expression </td> </tr>  <tr> <td> EVS Club </td> <td> To sensitise students to environmental issues </td> </tr>  <tr> <td> Heritage Club </td> <td> To create awareness and appreciation of Indian cultural heritage </td></tr>   <tr> <td> Computer Science Club </td> <td> To enhance the technical and practical skills of students and increase <br/> awareness about latest software </td>  </tr> <tr> <td> Photography Club </td> <td>  To learn Basics of Photography - Learning to compose a good photograph </td> </tr>   <tr> <td> Dramatics Club </td> <td> To learn essential acting, directing skills </td>  </tr> <tr> <td>  Calligraphy Club </td> <td>  To promote penmanship, to create a calligraphic culture </td> </tr>  <tr> <td>  Additional Activities </td> <td> I-Care (Social Work), Electronics, Painting, Health & Wellness, Music (Vocal & Instrumental), Consumer Matters & Astronomy </td> </tr>
                    </tbody>
                </table>
                </div>
         
                </div>
            </div>
            </div>
        </div>
     </>
  )
}

export default Clubs